export default __webpack_public_path__ + "static/media/TAGS_PERFUMES.6082da8b.png";